// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"d2ad1c02716c700d7923","655":"b751a9e486c493565f25"}[chunkId] + ".js";
};